import { connect } from 'react-redux';
import { getIsHotelOnly } from 'src/store/view/selectors';
import { goToPathAction, setShowSummaryAction } from '../../store/actions/view';
import { getPath } from '../../store/selectors/router';
import { getStepPath } from '../../utils/globalUtils';
import Topbar from './Topbar';
import { HOTEL_CHECKOUT_STEPS, TOUR_CHECKOUT_STEPS } from './constants';

const mapStateToProps = (state) => {
  const isHotelOnly = getIsHotelOnly(state);
  return {
    currentStep: getStepPath(getPath(state)),
    steps: isHotelOnly ? HOTEL_CHECKOUT_STEPS : TOUR_CHECKOUT_STEPS,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClickStep: (path) => dispatch(goToPathAction(path)),
  onOpenSummary: () => dispatch(setShowSummaryAction(true)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Topbar);
